import React, { useState, useEffect } from 'react';
import SecuritiesBasic from './SecuritiesBasic';
import { get_securities_documents } from '../../services/common';
import moment from 'moment';
import activeStatus from '../../assets/caprock/status/active.svg';
import pendingStatus from '../../assets/caprock/status/pending.svg';
import rejectStatus from '../../assets/caprock/status/reject.svg';
const SecuritiesDocs = ({ fumId, docType = '' }) => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (fumId) {
      getDocuments('');
    }
  }, [fumId]);

  const getDocuments = async (search) => {
    try {
      // const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}');
      // const userToken = localData['access-token'];
      const userToken = localStorage.getItem('systemToken') || "";
      
      const response = await get_securities_documents(userToken, fumId, docType, search);
      
      if (response.success === 200) {
        const docsData = response.docs || [];
        const processedDocs = docsData.map(doc => ({
          ...doc,
          doc_time: moment(doc.doc_time).format('DD MMM, YYYY'),
        }));
        setDocs(processedDocs);
      } else {
        setDocs([]);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      setDocs([]);
    } finally {
      setLoading(false);
    }
  };

  const openLink = (id) => {
    const link = document.getElementById(`URL${id}`)?.value;
    if (link) {
      window.open(link, '_blank');
    }
  };

  const handleTextSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      getDocuments(value);
    }, 300);
    setTimer(newTimer);
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  if (!fumId) {
    return null;
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <SecuritiesBasic fumId={fumId} />

      <div className="flex flex-col items-center my-3">
        <div className="w-full px-5 pt-4">
          <div className="p-4 mb-4 bg-gray-50 rounded-lg h-full">
            <div className="flex flex-col md:flex-row mt-3">
              <div className="w-full md:w-1/2 mb-2">
                <h5 className="text-gray-600 text-sm font-medium">
                  <b>Documents</b>
                </h5>
              </div>
              <div className="w-full md:w-1/2">
                <input
                  onChange={handleTextSearch}
                  value={searchTerm}
                  style={{ border: '1px solid grey', height: '35px', borderRadius: '5px' }}
                  type="text"
                  id="doc_search_input"
                  placeholder="Search doc name here.."
                  className="bg-white w-full pl-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            
            <div className="my-1">
              <div className="w-full overflow-x-auto">
                <table className="min-w-full table-auto border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Document Name</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Securities</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date Added</th>
                      <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docs.length > 0 ? (
                      docs.map((doc) => (
                        <tr key={doc.doc_id} className="hover:bg-gray-50">
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            <span className="flex items-center">
                              {doc.doc_status === 'Approved' && (
                                <img src={activeStatus} alt="Approved" style={{ width: 16, height: 16 }} />
                                     
                              )}
                              {doc.doc_status === 'Pending' && (
                                <img src={pendingStatus} alt="Pending" style={{ width: 16, height: 16 }} />

                              )}
                              {doc.doc_status === 'Rejected' && (
                                <img src={rejectStatus} alt="Rejected" style={{ width: 16, height: 16 }} />

                              )}
                              {doc.doc_id}
                            </span>
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_name}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_status}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            {doc.doc_time}
                          </td>
                          <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                            <input 
                              id={`URL${doc.doc_id}`} 
                              type="hidden" 
                              value={doc.doc_url} 
                            />
                            <div className="relative group">
                              <div 
                                className="text-lg text-blue-600 font-bold cursor-pointer select-none"
                                style={{ 
                                  writingMode: 'vertical-rl', 
                                  textOrientation: 'sideways',
                                  marginTop: '15px' 
                                }}
                              >
                                ...
                              </div>
                              <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                                <button
                                  onClick={() => openLink(doc.doc_id)}
                                  className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                >
                                  • Download
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                          No Records
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritiesDocs;
